export default "__VITE_ASSET__CwZM4q2W__"